module.exports = __webpack_public_path__ + "static/media/download-theme.048dffd8.svg";